<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3  v-if="driver" class="text-themecolor">{{ title }} for {{driver.name_first}} {{driver.name_last}}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol  v-if="driver" class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }} for {{driver.name_first}} {{driver.name_last}}</li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card" >
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Add New Vehicle</h4>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Vehicle Make</label>
                <select type="text" placeholder="Vehicle Make"
                        class="form-control ddown" v-model="new_make">
                  <option v-for="make in vehicleMakes" v-bind:value="make.id_make_vehicle">
                    {{ make.name }}
                  </option>
                </select>
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Vehicle Model</label>
                <input v-model="new_model" class="form-control" placeholder="Vehicle Model" type="text">
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Vehicle Year</label>
                <input v-model="new_year" class="form-control" placeholder="Vehicle Year" type="text">
              </div>
              <br>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Vehicle Type</label>
                <select type="text" placeholder="Vehicle Type" class="form-control ddown" v-model="new_type">
                  <option v-for="(type) in vehicleTypes" v-bind:value="type.id_type_vehicle">
                    {{ titleCase(type.code) + " - Capacity: " + type.capacity }}
                  </option>
                </select>
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>License Plate</label>
                <input v-model="new_license" class="form-control" placeholder="License Plate Number" type="text">
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>VIN #</label>
                <input v-model="new_vin" class="form-control" placeholder="VIN #" type="text">
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Decal #</label>
                <input v-model="new_decal" class="form-control" placeholder="Decal #" type="text">
              </div>
              <div  class="col-md-3 col-lg-3 p-0" style="margin-right: 30px; margin-bottom: 30px;">
                <label>Vehicle Image</label>
                <!--<input type="file" @change="Images_onFileChanged">-->
                <input type="file" id="id_image" ref="id_image" v-on:change="getBase64()"/>
              </div>
              <br>
            </div>
            <button id="save-vehicle-button" v-on:click="handleFileUpload()" class="btn btn-info waves-effect waves-light m-t-10" >Add Vehicle</button>
          </div>
        </div>
        <div class="card" >
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Current Vehicles</h4>
            </div>
          </div>
          <div class="card-body">
            <table class="table table-hover table-sm">
              <tbody class="col-12">
              <div v-for="vehicle in vehicles" class="row" style="display: flex; flex-direction: row; margin-bottom: 30px;">
                <!-- Checkbox -->
                <td style="border-top: 0">
                  <input type="radio" style="position: relative; left: 0; opacity: 1;" :checked="vehicle.deleted_at == null" v-on:change="changeVehicle(vehicle.id_vehicle)">
                </td>
                <img v-if="vehicle.id_image && vehicle.id_image.url" v-bind:src="vehicle.id_image.url" alt="user" class="vehicle-image">
                <font-awesome-icon v-else icon="car" style="height: 150px; width: 150px; color: grey; margin-right: 30px;"/>
                <div class="vehicle-details">
                  <div class="col-md-2 col-lg-2 p-0">
                    <h4>
                      Make and Model
                    </h4>
                    <span>
                      {{ vehicle.year + " " + vehicle.id_make_vehicle.name + " " + vehicle.model }}
                      </span>
                  </div>
                  <div class="col-md-2 col-lg-2 p-0">
                    <h4>
                      Vehicle Type
                    </h4>
                    <span>
                      {{ titleCase(vehicle.id_type_vehicle.code) + (vehicle.id_type_vehicle && vehicle.id_type_vehicle.capacity ? (" - " + vehicle.id_type_vehicle.capacity) : '') }}
                      </span>
                  </div>
                  <div class="col-md-2 col-lg-2 p-0">
                    <h4>
                      License Plate
                    </h4>
                    <span>
                      {{ vehicle.license_plate_number }}
                      </span>
                  </div>
                  <div class="col-md-2 col-lg-2 p-0">
                    <h4>
                      VIN #
                    </h4>
                    <span>
                      {{ vehicle.vin }}
                      </span>
                  </div>
                  <div class="col-md-1 col-lg-1 p-0">
                    <h4>
                      Decal #
                    </h4>
                    <span>
                      {{ vehicle.seti_decal }}
                      </span>
                  </div>
                </div>
              </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import Vue from 'vue'

  export default {
    metaInfo: {
      title: 'Wingz Support | Vehicles',
    },
    name: 'Vehicles',
    data () {
      return {
        title: 'Vehicles',
        data: {},
        id_driver: null,
        driver: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        prev_sort: null,
        routingNumber: '',
        accountNumber: '',
        ssn: '',
        name_first: '',
        name_last: '',
        email: '',
        phone_number: '',
        bio: '',
        user_vehicle: '',
        location_address_1: '',
        vehicles: null,
        vehicleMakes: null,
        vehicleTypes: null,
        new_make: null,
        new_model: null,
        new_type: null,
        new_license: null,
        new_vin: null,
        new_year: null,
        new_decal: null,
        selected_file: null,
        file: null,
        b64: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      getUserVehicles: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'vehicles/?id_driver=' + this.id_driver)
          .then(response => {
            console.log('user info response', response.data)
            this.vehicles = response.data.results
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.getVehicleMake()
          })
      },
      titleCase: function(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
      },
      changeVehicle: function(id_vehicle) {
        this.isLoading = true
        var params = {"deleted_at": null}
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'vehicles/' + id_vehicle + '/', params)
          .then(response => {
          })
          .catch(error => {
            console.log('vehicle error', error)
          })
          .finally(() => {
            this.getUserVehicles()
          })
      },
      getVehicleMake: function() {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'make-vehicles/')
          .then(response => {
            console.log('getVehiclesMake response', response)
            this.vehicleMakes = response.data
          })
          .catch(error => {
            console.log('vehicle error', error)
          })
          .finally(() => {
            this.getVehicleType()
          })
      },
      getVehicleType: function() {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'type-vehicles/')
          .then(response => {
            console.log('getVehiclesType response', response.data)
            this.vehicleTypes = response.data
          })
          .catch(error => {
            console.log('vehicle error', error)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getBase64: function () {
        var reader = new FileReader();
        var file = this.$refs.id_image.files[0]
        reader.onload = function (e) {
          return reader.result
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.b64 = reader.result
        }
      },
      handleFileUpload: function () {
        if (this.id_driver == null || this.new_make == null || this.new_model == null || this.new_type == null || this.new_license == null || this.new_vin == null || this.new_year == null || this.new_decal == null) {
          Vue.toasted.show('Please fill in all fields', {
            theme: 'bubble',
            position: 'top-right',
            duration: 3000
          })
        }
        else{
          this.isLoading = true
          var params = {
            'file': this.b64,
            'id_driver': this.id_driver,
            'id_make_vehicle': this.new_make,
            'model': this.new_model,
            'id_type_vehicle': this.new_type,
            'license_plate_number': this.new_license,
            'vin': this.new_vin,
            'year': this.new_year,
            'seti_decal': this.new_decal
          }
          console.log('upload params', params)
          this.$http
            .post(process.env.API_BASE_URL_CS + 'vehicles/', params)
            .then(response => {
              console.log('SUCCESS', response.data)
              this.new_make = null
              this.new_model = null
              this.new_type = null
              this.new_license = null
              this.new_vin = null
              this.new_year = null
              const input = this.$refs.id_image
              input.type = 'text'
              input.type = 'file'
            })
            .catch(error => {
              console.log('FAILURE', error)
            })
            .finally(() => {
              this.getUserVehicles()
            })
        }
      },
    },
    mounted () {
      this.id_driver = this.getUser()['id_user']
      this.getUserVehicles()
    },
    created () {
      // document.title = "Verida Support | Driver Dashboard";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table td, .table th {
    vertical-align: middle;
    padding: .85rem;
  }

  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }
  .search-label {
    margin-right: 20px;
  }

  .vehicle-details {
    flex: 1;
    display: inherit;
  }
  .vehicle-image {
    width: 150px; 
    height: 150px; 
    margin-right: 30px;
    object-fit: cover;    
  }

  @media screen and (max-width: 768px) {
    .vehicle-details {
      flex-direction: column;
      width: 100px;
    }

    .vehicle-details > div{
      margin-bottom: 3px;
    }
    .vehicle-details h4 {
      font-weight: 500;
      line-height: 5px;
      font-size: 10px;
      margin-bottom: 0px;
    }
    .vehicle-details span {
      font-weight: 500;
    }

    .vehicle-image {
      width: 120px; 
      height: 120px; 
      margin-right: 20px;
      object-fit: cover;    
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Vehicles.vue